import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.ip');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-ip',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.admin.ip/view.scss */
/* src/app/page.admin.ip/view.scss: no such file or directory */`],
})
export class PageAdminIpComponent implements OnInit {
    public list: any[] = [];
    public loading: boolean = true;
    public search: any = { text: '' };
    public pagination: any = { current: 1, start: 0, end: 0 };
    public sortField: string = 'created';
    public sortOrder: string = 'DESC';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load(page: number = 1) {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("search", {
            text: this.search.text,
            page: page,
            dump: 20,
            orderby: this.sortField,
            order: this.sortOrder,
        });

        if (code === 200) {
            this.list = data.rows || [];
            const total = data.total || 0;
            const dump = data.dump || 20;
            const lastpage = Math.ceil(total / dump);
            this.pagination = {
                current: page,
                start: lastpage > 1 ? 1 : 0,
                end: lastpage
            };
        }

        this.loading = false;
        await this.service.render();
    }

    public async onSearch(event?: KeyboardEvent) {
        if (event && event.key !== 'Enter') return;
        await this.load(1);
    }

    public async clearSearch() {
        this.search.text = '';
        await this.load(1);
    }

    public async onSort(event: { field: string, order: string }) {
        this.sortField = event.field;
        this.sortOrder = event.order;
        await this.load(1);
    }
}

export default PageAdminIpComponent;